import { render } from "./InquiryAgree.vue?vue&type=template&id=78d983b8"
import script from "./InquiryAgree.vue?vue&type=script&lang=js"
export * from "./InquiryAgree.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__